import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../helpers';
import { Roles, SupervisionNoteStatus } from '../constants';

import type { RootState } from '../store';

function useGroupSupervisionEditable() {
  const { user } = useSelector((state: RootState) => state.auth);
  const { current: groupParentSN } = useSelector(
    (state: RootState) => state.groupParentSupervision,
  );
  const [isEditable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
    if (!user) return;
    if (
      !areUserRolesIn(user?.roles, [Roles.Bcba]) ||
      !groupParentSN ||
      !groupParentSN?.id ||
      groupParentSN?.status === SupervisionNoteStatus.Completed
    ) {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  }, [user, groupParentSN]);

  return isEditable;
}

export default useGroupSupervisionEditable;
